
import { SvgIconProps, useTheme } from "@mui/material";
import { IconTypes } from "./types";
import { icon2iconUrl } from "./constant";

export type CustomIconProps = {
  icon: IconTypes;
};

export const LargeCustomIcon = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();
  const Res = icon2iconUrl[props.icon];
  const IconComponent = Res.type;
  const stroke = props.stroke ? props.stroke : theme.palette.primary.dark;

  return <IconComponent width={24} height={24} {...props} stroke={stroke} />;
};
